import Text from "../../../../framework/component/form/input-types/Text";
import RegistrationModel from "../model/RegistrationModel";
import React from "react";
import FileUpload from "../../../../framework/component/form/input-types/FileUpload";
import {useFormContext} from "react-hook-form";

/**
 * This component represents the part of the registration form for information not related to any other panel
 */
export default function Others() {
  const {formState: {errors}} = useFormContext<RegistrationModel>();

  return <>
    <FileUpload<RegistrationModel>
        label="MRC Certificate"
        multiple={false}
        helpText={<span style={{
          whiteSpace: "normal" // This specific help text we want to always show all the text
        }}>Please upload your test completion certificate for the MRC training. Please ensure this
          document includes
          your test pass mark as we will not accept attendance certificates.</span>}
        fieldId={"other.mrcfiles"}
        mandatory
        acceptedTypes={".pdf"}
    />
    <Text<RegistrationModel>
        label={"Notes"}
        helpText={"Is there anything else you wish to tell us about your registration request?"}
        error={errors.other?.notes}
        fieldId={"other.notes"}
        textArea
        charCount
        maxLength={500}/>
  </>
}
